export default __webpack_public_path__ + "static/media/wecook.67a14bae.png";